import React, { useState, useEffect, useRef } from 'react';

import { Button, Spinner, FormGroupRadio, SearchBox } from "components";

import { cloneArray, isFunction , deepCloneArray, func_validation, isArrayEmpty, isArrayNotEmpty, isCompletelyEqual, isNumberValid, getArrayLength, isStringTrimNotEmpty, isArray, isStringTrimEmpty } from 'functions';

import ic_search from "assets/images/ic_search.svg";
import ic_small_close from "assets/images/ic_small_close.svg";
import ic_expander from "assets/images/ic_expander.svg";

import "assets/scss/components/form/listBox.scss";
import { FormCheckbox } from './formCheckbox/FormCheckbox';
import { Toaster } from 'components/notification/Toaster';



export function ListBox(props) {
    const {
        className,
        listClassName, listWrapperClassName, listBodyClassName,
        title, isInputRequired,
        customSelectionIndicatorTxt,

        isHeaderHidden,
        list: list_props, 
        /*
            list = [{ 
                label: "", 
                data: any, 
                isSelected: boolean, 
                isExpanded: boolean,
                isDisabled: boolean, 
                disabledMsg: "",
                subList: [{}] 
            }]
        */
        isListLoading,
        maxSelection,

        searchInputPlaceholder, isSearchable,
        
        isFormSubmissionAttempted,
        isActionVisible, actionButtonTxt, isActionLoading, 
        isResetRequired, isDisabled, isActionDisabled,

        isListRadio,

        // Functions
        onActionClick = () => {}
    } = props;

    let title_validated = isStringTrimNotEmpty(title)? title:"";
    let actionButtonTxt_validated = isStringTrimNotEmpty(actionButtonTxt)? actionButtonTxt:"";
    let customSelectionIndicatorTxt_validated = (isStringTrimNotEmpty(customSelectionIndicatorTxt))? " " + customSelectionIndicatorTxt: " Selected"; 
    let initSelectedData = [];
    if (isArrayNotEmpty(list_props)) {
        for (let i = 0; i < list_props.length; i++) {
            let details = list_props[i];
            if (details?.isSelected && details?.data) 
                initSelectedData.push(details?.data);
        }
    }

    // States
    const [list, setList] = useState(list_props);
    const selectedData = useRef(initSelectedData);
    const [isSearchInputVisible, setIsSearchInputVisible] = useState(false);
    const [isSearchIconVisible, setIsSearchIconVisible] = useState(true);
    const [isRerenderRequired, setIsRerenderRequired] = useState();

    useEffect(() => {
        if (isArray(list_props)) {
            setList(list_props);

            let initSelectedData = [];
            if (isArrayNotEmpty(list_props)) {
                for (let i = 0; i < list_props.length; i++) {
                    let details = list_props[i];
                    if (details?.isSelected && details?.data) 
                        initSelectedData.push(details?.data);
                }
            }
            selectedData.current = initSelectedData;
            setIsRerenderRequired(JSON.stringify(initSelectedData));
        }
    }, [JSON.stringify(list_props)]);


    function handleOnActionClick() {
        let selectedData = [];
        function getSelectedData(list, recursiveDepth) {
            let newList = deepCloneArray(list);

            if (isArrayNotEmpty(newList)) {
                for (let i = 0; i < newList.length; i++) {
                    let details = newList[i];

                    if (isArrayNotEmpty(details?.subList)) {
                        details.subList = getSelectedData(details?.subList, recursiveDepth + 1);
                    }

                    if (isArrayEmpty(details?.subList) || !(details?.subList)) {
                        if (details?.isSelected) {
                            selectedData.push(details?.data);
                        }
                        else {
                            newList.splice(i, 1);
                            i--;
                        }
                    }

                    // Reset after handling all logic above
                    details.isSelected = false;
                }

                return newList;
            }
            return [];
        }
        let selectedFullDetailsList = getSelectedData(list, 1);
        if (isArrayNotEmpty(selectedData) &&
            isArrayNotEmpty(selectedFullDetailsList)) 
            onActionClick(selectedData, selectedFullDetailsList);
    }
    function handleOnCheckBoxChange(isChecked, isMain, data) {
        let newData = [];
        if (isMain &&
            isArrayNotEmpty(list)) {
                
            if (isChecked) {
                list.map((details) => {
                    newData.push(details?.data);
                });

                if (isNumberValid(maxSelection)) {
                    if (getArrayLength(selectedData.current) < maxSelection) {
                        selectedData.current = newData;
                    }
                    else {
                        Toaster({
                            type: "info",
                            msg: "Max. selection reached"
                        })
                    }
                }
                else selectedData.current = newData;
            }
            else selectedData.current = [];
        }
        else {
            newData = [data];
            if (isChecked) {
                if (isNumberValid(maxSelection)) {
                    if (getArrayLength(selectedData.current) < maxSelection) {
                        newData = newData.concat(selectedData.current);
                    }
                    else {
                        Toaster({
                            type: "info",
                            msg: "Max. selection reached"
                        })
                    }
                }
                else newData = newData.concat(selectedData.current);
            }
            else if (isArrayNotEmpty(selectedData.current)) {
                newData = deepCloneArray(selectedData.current);
                for (let i = 0; i < newData.length; i++) {
                    if (isCompletelyEqual(newData[i], data)) {
                        newData.splice(i, 1);
                        break;
                    }
                }

            }
            selectedData.current = newData;
        }

        setIsRerenderRequired(JSON.stringify(newData));

        if (isFunction(props.updateParentState))
            props.updateParentState(newData);

        if (isFunction(props.onHandleOnCheckBoxChange))
            props.onHandleOnCheckBoxChange(isChecked, isMain, data);
    }

    function filterList(searchTerm) {
        let filteredList = [];
        list_props.map((obj, idx) => {
            let label = obj?.label;

            if ((isStringTrimNotEmpty(label) &&
                label.toLowerCase().startsWith(searchTerm.toLowerCase())) || 
                    isStringTrimEmpty(searchTerm)) {
                filteredList.push(obj);
            }
        });

        setList(filteredList);
    }

    useEffect(() => {
        if (isResetRequired) setList(list_props);
    }, [isResetRequired]);


    let content = [];
    if (isListRadio) {
        let iniSelectedValue;
        if (isArrayNotEmpty(list)) {
            list.map((details, idx) => {
                if (details?.isSelected) iniSelectedValue = JSON.stringify(details?.data);
            })
        }

        content = (
            <FormGroupRadio
                className={"body__radio-wrapper"}
                radioClassName={"radio-wrapper__item"}
                radioList={isArrayNotEmpty(list)? list.map((details) => {
                    return {
                        label: details?.label,
                        value: JSON.stringify(details?.data)
                    };
                }):[]}

                handleRadioChange={(data) => {
                    let selectedData = JSON.parse(data);
                    let newList = deepCloneArray(list);
                    setList(newList.map((obj) => {
                        return {
                            ...obj,
                            isSelected: (obj?.data === selectedData)
                        }
                    }));

                    if (isFunction(props.updateParentState))
                        props.updateParentState(selectedData);
                }}
                defaultSelectedRadio={iniSelectedValue}
            />
        );
    }
    else if (isArrayNotEmpty(list)) {
        let newArray = deepCloneArray(list);

        function generateCheckboxes(data, idx, recursiveDepth) {
            let label_validated = (data?.label)? data.label:"Item " + (idx + 1);

            // check for indeterminate state
            let isIndeterminate = false;
            let subList = data?.subList;
            if (isArrayNotEmpty(subList)) {
                let isAnyChecked = false;
                let isAnyUnchecked = false;
                subList.map((details) => {
                    if (details?.isSelected) isAnyChecked = true;
                    else isAnyUnchecked = true;
                });

                if (isAnyChecked && isAnyUnchecked)
                    isIndeterminate = true;
            }

            let isExpanded = data?.isExpanded;
            let isSelected = false;
            if (isArrayNotEmpty(selectedData.current)) {
                selectedData.current.map((storedData) => {
                    if (isCompletelyEqual(data?.data, storedData)) {
                        isSelected = true;
                    }
                })
            }

            return (
                <div key={idx}>
                    <div className="body__item d-flex align-items-center"
                        style={{ paddingLeft: (recursiveDepth * 25 + 15) + "px" }}
                    >
                        {/* Checkbox */}
                        <FormCheckbox
                            checkboxClassName={"item__checkbox"}
                            isCheckboxDisabled={data?.isDisabled || (!isSelected && getArrayLength(selectedData.current) >= maxSelection)}
                            disabledMsg={data?.disabledMsg}
                            
                            checkboxIconClassName={"checkbox__icon"}
        
                            isCheckboxCheckedDefault={data?.isSelected}
                            isMainCheckboxIndeterminate={isIndeterminate}

                            handleCheckboxSelectionSub={(checkboxID, isChecked) => { 
                                data.isSelected = isChecked;
                                function updateCheck(subList) {
                                    if (isArrayNotEmpty(subList)) {
                                        subList.map((data) => {
                                            data.isSelected = isChecked;
                                            if (isArrayNotEmpty(data?.subList)) {
                                                updateCheck(data.subList);
                                            }
                                        });
                                    }
                                }
                                updateCheck(subList);

                                function updateParentCheckboxes(newArray) {
                                    if (isArrayNotEmpty(newArray)) {
                                        let isEverySubCheckboxesChecked = true;
                                        newArray.map((details) => {
                                            if (isArrayNotEmpty(details?.subList)) {
                                                details.isSelected = updateParentCheckboxes(details?.subList);
                                            }

                                            if (!(details?.isSelected)) 
                                                isEverySubCheckboxesChecked = false;
                                        });

                                        return isEverySubCheckboxesChecked;
                                    }
                                    return false;
                                }
                                updateParentCheckboxes(newArray);

                                setList(newArray);
                                handleOnCheckBoxChange(isChecked, false, data?.data); 
                            }}

                            isDecoration_lightBackground isCheckboxIconVisible
                        />

                        <div className={"item__label-wrapper d-flex align-items-center "}
                            onClick={() => {
                                data.isExpanded = !isExpanded;
                                setList(newArray);
                            }}
                        >
                            {/* Expander */}
                            {isArrayNotEmpty(subList) && (
                                <img
                                    className={"label-wrapper__expander " +
                                        (isExpanded? "label-wrapper__expander_rotate ":"")}
                                    src={ic_expander}
                                />
                            )}

                            {/* Label */}
                            <div className="label-wrapper__label">
                                {label_validated}
                            </div>
                        </div>
                        
                    </div>

                    {/* Expanded Content */}
                    {isArrayNotEmpty(subList) && isExpanded && (
                        <div className={"body__expanded-item"}>
                            {subList.map((data, idx) => {
                                return generateCheckboxes(data, idx, recursiveDepth + 1);
                            })}
                        </div>
                    )}
                    
                </div>
            )
        }

        content = newArray.map((data, idx) => {
            return generateCheckboxes(data, idx, 0);
        })
    }

    let isMainCheckboxChecked = false;
    let isMainCheckboxIndeterminate = false;
    let isNoneChecked = true;
    let totalSelections = 0;
    if (isArrayNotEmpty(list)) {
        let isAnyChecked = false;
        let isAnyUnchecked = false;
        list.map((details) => {
            if (details?.isSelected) {
                isAnyChecked = true;
                isNoneChecked = false;
                
                if (isArrayEmpty(details?.subList) ||
                    !(details?.subList)) {
                    totalSelections++;
                }
            }
            else isAnyUnchecked = true;

            function traverseList(list) {
                if (isArrayNotEmpty(list)) {
                    list.map((details) => {
                        if (details?.isSelected && 
                            (isArrayEmpty(details?.subList) ||
                                !(details?.subList))) {
                            totalSelections++;
                        }
        
                        if (isArrayNotEmpty(details?.subList)) {
                            traverseList(details.subList);
                        }
                    });
                }
            }
            traverseList(details?.subList);
        });
        

        if (isAnyChecked && !isAnyUnchecked) isMainCheckboxChecked = true;
        if (isAnyChecked && isAnyUnchecked) isMainCheckboxIndeterminate = true;
    }

    let listHeaderLabel = isNoneChecked? "Select All": "Deselect All";

    // Error Checking (Default)
    let isError = (isFormSubmissionAttempted && (totalSelections == 0) && isInputRequired);

    return (
        <div className={"component-list-box " +
                (className? className + " ":"")}>
            <div className="component-list-box__wrapper">
                {/* Labels */}
                <div className="wrapper__labels d-flex justify-content-between align-items-center">
                    <div className="labels__title">
                        {title_validated}{isInputRequired? <span className={"labels__title-asterisk"}>*</span>:""}
                    </div>

                    {(!isListRadio)? (
                        <div className="labels__selection-count">
                            {totalSelections && (totalSelections > 0)? totalSelections + customSelectionIndicatorTxt_validated:""}
                        </div>
                    ):""}
                </div>

                {/* List */}
                <div className={"wrapper__list-wrapper " +
                        (listClassName? listClassName + " ":"") +
                        (isActionVisible? "wrapper__list-wrapper_bottom-padding ":"")}>

                    <div className={"list-wrapper__list " +
                        (listWrapperClassName? listWrapperClassName + " ":"") +
                        (isError? "list-wrapper__list_error ":"")}>
                            
                            {/* Header */}
                            {(!isHeaderHidden) && !isNumberValid(maxSelection)? (
                                <div className="list__header">

                                    {isSearchable && isSearchInputVisible? (
                                        <div className={"header__search-input d-flex align-items-center "}>
                                            {/* Search Input */}
                                            <SearchBox
                                                className={"search-input__input flex-fill"}
                                                placeholder={isStringTrimNotEmpty(searchInputPlaceholder)? searchInputPlaceholder:"Search..."}
                                                handleOnChange={filterList}
                                            />

                                            {/* Hide Search Input */}
                                            <img
                                                className={"search-input__hide-icon"}
                                                src={ic_small_close}
                                                onClick={() => {
                                                    setIsSearchIconVisible(true);
                                                    setIsSearchInputVisible(false);
                                                    setList(list_props);
                                                }}
                                            />
                                        </div>
                                    ):(
                                        <div className={"header__main-display d-flex justify-content-between"}>
                                            {/* Checkbox */}
                                            {(!isListRadio)? (
                                                <FormCheckbox
                                                    checkboxClassName={"main-display__checkbox"}
                                                    iconClassName={"checkbox__icon"}
                                                    isCheckboxDisabled={isDisabled}
                                                    disabledMsg={"Unable to select all"}

                                                    labelClassName={"checkbox__label"}
                                                    checkboxLabel={listHeaderLabel}

                                                    checkboxID={"main"}
                                                    mainCheckboxID={"main"}
                                                    
                                                    isMainCheckboxChecked={isMainCheckboxChecked}
                                                    isMainCheckboxIndeterminate={isMainCheckboxIndeterminate}
                                                    handleCheckboxSelectionMain={(checkboxID, isChecked) => {
                                                        let newArray = deepCloneArray(list);
                                                        function setCheckbox(newArray) {
                                                            if (isArrayNotEmpty(newArray)) {
                                                                newArray.map((details) => {
                                                                    if (isChecked) details.isSelected = true;
                                                                    else details.isSelected = false;

                                                                    if (isArrayNotEmpty(details?.subList)) {
                                                                        setCheckbox(details?.subList);
                                                                    }
                                                                });
                                                            }
                                                        }
                                                        setCheckbox(newArray);
                                                        setList(newArray);

                                                        handleOnCheckBoxChange(isChecked, true)
                                                    }}
                                                    
                                                    isDecoration_lightBackground
                                                />
                                            ):""}

                                            {isSearchable && isSearchIconVisible? (
                                                <img
                                                    className={"main-display__search-icon"}
                                                    src={ic_search}
                                                    onClick={() => { 
                                                        setIsSearchInputVisible(true); 
                                                        setIsSearchIconVisible(false);
                                                    }}
                                                />
                                            ):""}
                                        </div>
                                    )}
                                </div>

                            ):""}

                        <div className={"list__body " +
                                (listBodyClassName? listBodyClassName + " ":"")} >
                            {isListLoading? (
                                <div className={"d-flex align-items-center justify-content-center h-100 w-100"}>
                                    <Spinner/>
                                </div>
                            ):content}
                        </div>  
                    </div>
                </div>

                {/* Error Message */}
                {isError? (<span className="list-wrapper__error-message">{"Required"}</span>):""}

                {/* Action */}
                {isActionVisible? (
                    <div className="list-wrapper__action">
                        <Button
                            className={"action__button"}
                            handleOnClick={handleOnActionClick}
                            isLoading={isActionLoading}
                            isDisabled={isActionDisabled || isDisabled}
                        >
                            {actionButtonTxt_validated}
                        </Button>
                    </div>
                ):""}
            </div>
        </div>
    )
}